import React from "react";
import Form, { GroupItem, Label, SimpleItem } from "devextreme-react/form";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import { ScrollView } from "devextreme-react/scroll-view";
import ButtonDx from "devextreme-react/button";
import SaveToTherefore from "../services/SaveToTherefore";
import GetAttachmentBlobFiles from "./../services/GetAttachmentBlobFile";
import { withSnackbar } from "notistack";
import GetFileData from "../services/GetFileData";
import { jsPDF } from "jspdf";
import DropDownBox from "devextreme-react/drop-down-box";
import { DocTypes } from "./../statics/DocTypes";
import DataGrid, {
  Column,
  FilterRow,
  Selection,
  Scrolling
} from "devextreme-react/data-grid";

function ThereforePopup(props) {
  const [dropdownValues, setDropdownValues] = React.useState();
  const onHidden = () => {
    props.handleModalClose();
  };

  const btnRender = () => {
    return (
      <div>
        <ButtonDx
          className="btnSubmit"
          id="button"
          text="Save"
          useSubmitBehavior={true}
          onClick={processForm}
        />
      </div>
    );
  };

  const getMessageAsPDF = (message, mailboxOwner) => {
    const { body, from, subject, attachments } = message;

    const pageWidth = 8.5;
    const lineHeight = 1.2;
    const margin = 0.5;
    const maxLineWidth = pageWidth - margin * 2;
    const fontSize = 12;
    const doc = new jsPDF({
      unit: "in",
      lineHeight: lineHeight
    });

    const pdfText =
      "From: " +
      from +
      "\n To : " +
      mailboxOwner +
      "\n Subject: " +
      subject +
      "\n" +
      body;
    const textLines = doc
      .setFont("helvetica")
      .setFontSize(fontSize)
      .splitTextToSize(pdfText, maxLineWidth);

    //IT CREATES A NEW PDF PAGE
    let n = 0;
    let lineStart = 0;
    let lineEnd = 53;
    while (textLines.length > 53 * n) {
      if (n > 1) {
        doc.addPage("a4");
      }
      doc.text(textLines.slice(lineStart, lineEnd), margin, margin);
      //adds page numbers to the pdf
      lineStart = lineEnd;
      lineEnd += 53;
      n++;
    }
    return doc;
  };

  const getMessageAttachment = async (pdf) => {
    var formData = new FormData();
    formData.append("File", pdf);
    const getFileData = new GetFileData(props.apiClass);
    let retFile = await getFileData.callApi(formData);
    return retFile;
  };

  const setAttachments = async (file) => {
    let inputAttachments = [];
    file.forEach((item) => {
      let inputDoc = {
        Name: item.name,
        Data: item.data
      };
      inputAttachments.push(inputDoc);
    });

    let messageDoc = getMessageAsPDF(props.messageContents, props.mailbox);

    let blobPDF = new Blob([messageDoc.output("blob")], {
      type: "application/pdf"
    });
    let pdfFile = new File(
      [blobPDF],
      props.messageContents.subject +
        " " +
        props.rowData.Office +
        props.rowData.Account +
        ".pdf"
    );

    let attach = await getMessageAttachment(pdfFile);

    inputAttachments.push(attach);
    return inputAttachments;
  };

  const onFieldDataChanged = async (curForm) => {
    let newForm = props.rowData;
    let field = curForm.dataField,
      data = curForm.value;

    newForm[field] = data;
    props.setRow(newForm);
  };

  const processForm = async () => {
    const getAttachmentBlobFiles = new GetAttachmentBlobFiles(props.apiClass);
    const saveToTherefore = new SaveToTherefore(props.apiClass);

    var ret = [];

    await getAttachmentBlobFiles.callApi(props.attachments).then((res) => {
      ret = res;
    });

    let attachments = await setAttachments(ret);

    let params = {
      Office: props.rowData.Office,
      Account: props.rowData.Account,
      DocType: props.rowData.Doc_Type,
      messageAttachments: attachments
    };

    await saveToTherefore.callApi(params).then((ret) => {
      props.enqueueSnackbar("Message was saved to Therefore", {
        variant: "success",
        style: { whitespace: "pre-line" }
      });
      props.handleModalClose();
    });
  };

  const onSelectionChange = (value) => {
    let newForm = props.rowData;
    newForm["Doc_Type"] = value.currentSelectedRowKeys[0].name;
    setDropdownValues(value.selectedRowKeys);
    props.setRow(newForm);
  };

  const dataGridRender = () => {
    return (
      <ScrollView>
        <DataGrid dataSource={DocTypes} onSelectionChanged={onSelectionChange}>
          <Selection mode={"single"} />
          <Scrolling mode={"infinite"} />
          <FilterRow visible={true} />
          <Column key="1" dataField="name" dataType="string" />
        </DataGrid>
      </ScrollView>
    );
  };

  return (
    <div>
      <Popup
        width={"70vw"}
        height={"60vh"}
        maxHeight={"1000px"}
        showTitle={true}
        title={`Archive to Therefore Form`}
        dragEnabled={false}
        closeOnOutsideClick={false}
        visible={true}
        shading={true}
        shadingColor="rgba(0, 0, 0, 0.2)"
        onHidden={onHidden}
      >
        <ToolbarItem location="after" toolbar={"bottom"} render={btnRender} />
        <ScrollView width="100%" height="100%">
          <Form
            id="form"
            showColonAfterLabel={false}
            labelLocation="top"
            formData={props.rowData}
            onFieldDataChanged={onFieldDataChanged}
          >
            <GroupItem key={"ThereforeFormFOSA"} colCount={3}>
              <SimpleItem
                key={"Office"}
                isRequired={true}
                editorOptions={{ placeholder: "Office" }}
                dataField={"Office"}
              >
                <Label text={"Office"} />
              </SimpleItem>
              <SimpleItem
                key={"Account"}
                isRequired={true}
                editorOptions={{ placeholder: "Account" }}
                dataField={"Account"}
              >
                <Label text={"Account"} />
              </SimpleItem>
              <SimpleItem
                key={"DocType"}
                isRequired={true}
                dataField={"Doc_Type"}
              >
                <DropDownBox
                  value={dropdownValues}
                  displayExpr={"name"}
                  placeholder="Select a Value..."
                  dataSource={DocTypes}
                  contentRender={dataGridRender}
                />
              </SimpleItem>
            </GroupItem>
          </Form>
        </ScrollView>
      </Popup>
    </div>
  );
}

export default withSnackbar(ThereforePopup);
